module.exports = __webpack_public_path__ + "img/xrpx_tokencreate.308daf3.png";